import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";

import { selectProductByIdentifier } from "@bca-compose/store/compose.selectors";
import { ProductIdentifier } from "@bca-shared/models/_enums";
import { ProductId } from "@bca-shared/models/_types";
import { IProduct } from "@bca-shared/models/product";
import { AppActionTypes } from "@bca-store/app.actions";
import { IState } from "@bca-store/app.reducer";

@Component({
  selector: "bca-product-dialog",
  templateUrl: "product-dialog.component.html",
})
export class ProductDialogComponent implements OnInit {
  @Output() productSelected = new EventEmitter<IProduct>();
  @Output() closeProductDialog = new EventEmitter<any>();


  currentProduct: string | null = null;
  ProductIdentifier = ProductIdentifier;

  active$: Observable<boolean>;
  product$: Observable<IProduct | undefined>;
  currentProductIdentifier$: Observable<ProductId>;


  constructor(private store: Store<{ app: IState }>) {}

  ngOnInit(): void {
    this.store
      .select("app")
      .pipe(
        map((state) => {
          const productKeys = Object.keys(state.dialogStatus);
          const activeKey = productKeys.find((key) => state.dialogStatus[key]);
          this.currentProduct = activeKey || null;
          return this.currentProduct;
        }),
      )
      .subscribe(() => {
        this.product$ = this.store.select(
          selectProductByIdentifier(this.currentProduct),
        );
        this.product$.subscribe((product) => {});
      });
  }

  onAccept(): void {
    if (this.currentProduct) {
      this.product$.pipe(take(1)).subscribe((product) => {
        if (product) {
          this.productSelected.emit(product);
        }
      });
    }
    this.closeDialog();
  }

  onDecline(): void {
    this.closeDialog();
  }

  closeDialog(): void {
    if (this.currentProduct) {
      this.store.dispatch({
        type: AppActionTypes.SetDialogStatus,
        payload: { visible: false, identifier: this.currentProduct },
      });
    }
    this.closeProductDialog.emit()
  }

  openDialog(productIdentifier: string): void {
    this.store.dispatch({
      type: AppActionTypes.SetDialogStatus,
      payload: { visible: true, identifier: productIdentifier },
    });
  }
}
